// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","Intro":"App_Intro__2O8au"};